import React from "react";
import { useParams, Link } from "react-router-dom";
import { MarketingLayout } from "@/components/Layout/MarketingLayout";
import { useLang } from "@/contexts/LanguageContext";

export default function Legal() {
  const { doc } = useParams();
  const { lang } = useLang();
  const isAr = lang === "ar";
  const isPrivacy = doc === "privacy";

  return (
    <MarketingLayout>
      <div className="max-w-3xl mx-auto px-5 py-10 prose-sm" dir={isAr ? "rtl" : "ltr"} data-testid={`legal-${doc}`}>
        <Link to="/" className="text-sm text-[var(--so-orange)] font-semibold">← {isAr ? "الرئيسية" : "Home"}</Link>
        <h1 className="text-3xl font-bold mt-4 mb-2">
          {isPrivacy ? (isAr ? "سياسة الخصوصية" : "Privacy Policy") : (isAr ? "الشروط والأحكام" : "Terms & Conditions")}
        </h1>
        <p className="text-xs text-[var(--so-text-soft)] mb-6">{isAr ? "آخر تحديث: يونيو 2026" : "Last updated: June 2026"}</p>

        <div className="space-y-4 text-sm leading-relaxed text-[var(--so-text-soft)]">
          <section>
            <h2 className="text-lg font-bold text-[var(--so-text)]">{isAr ? "الوصول إلى الموقع" : "Location Access"}</h2>
            <p>
              {isAr
                ? "باستخدامك ServeOn، فإنك تمنحنا الإذن بالوصول إلى موقع جهازك. نستخدم موقعك لتحديد ولايتك، والتأكد من توفر الخدمة في منطقتك، وربطك بأقرب مقدمي الخدمات والأنشطة التجارية. إذا لم تكن ولايتك مفعّلة بعد، فلن تتمكن من إكمال التسجيل حتى نطلق الخدمة في منطقتك."
                : "By using ServeOn, you grant us permission to access your device location. We use your location to determine your state, confirm service availability in your area, and connect you with the nearest providers and businesses. If your state is not active yet, you will not be able to complete registration until we launch in your area."}
            </p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[var(--so-text)]">{isAr ? "التحقق عبر الهاتف" : "Phone Verification"}</h2>
            <p>
              {isAr
                ? "نتحقق من رقم هاتفك عبر رمز يُرسل برسالة نصية (SMS). يجب إدخال الرمز لتفعيل حسابك. أنت مسؤول عن الحفاظ على سرية الرمز."
                : "We verify your phone number via a one-time code sent by SMS. You must enter the code to activate your account. You are responsible for keeping your code confidential — never share it with anyone."}
            </p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[var(--so-text)]">{isAr ? "استخدام الخدمة" : "Use of Service"}</h2>
            <p>
              {isAr
                ? "ServeOn منصة تربط العملاء بالمطاعم والمتاجر ومقدمي الخدمات والسائقين. نحن لا نفرض عمولة على الطلبات؛ يعتمد نموذج الإيرادات على الاشتراكات ورسوم التوصيل."
                : "ServeOn is a platform connecting customers with restaurants, stores, service providers and drivers. We charge 0% commission on orders; our revenue model is based on subscriptions and delivery fees."}
            </p>
          </section>
          {isPrivacy && (
            <section>
              <h2 className="text-lg font-bold text-[var(--so-text)]">{isAr ? "بياناتك" : "Your Data"}</h2>
              <p>
                {isAr
                  ? "نجمع اسمك ورقم هاتفك وموقعك التقريبي لتقديم الخدمة. لا نبيع بياناتك الشخصية لأطراف ثالثة."
                  : "We collect your name, phone number and approximate location to provide the service. We do not sell your personal data to third parties."}
              </p>
            </section>
          )}
        </div>
      </div>
    </MarketingLayout>
  );
}
